<form [formGroup]="form">
  <div class="p-4 mt-3 bg-surface border rounded-md">
    <div class="flex justify-between">
      <span
        class="custom-link-button bg-gray-200 rounded cursor-pointer"
        (click)="scanOrder()"
      >
        {{ '#DOCUMENTATION.ACTION.SCAN_ORDER' | translate }}
        <i class="ml-2" [ngClass]="'fa-regular fa-barcode-scan'"></i>
      </span>
      <span
        class="custom-link-button bg-gray-200 rounded cursor-pointer"
        (click)="showRecentObjectsDialog()"
      >
        {{ '#DOCUMENTATION.ACTION.RECENT_OBJECTS' | translate }}
        <i class="ml-2" [ngClass]="'fa-regular fa-clock-rotate-left'"></i>
      </span>
    </div>
    <div class="mt-4 gap-3">
      <div>
        <label for="object" class="soft-label top required">{{
          '#DOCUMENTATION.CREATE.OBJECTNUMBER' | translate
        }}</label>
        <soft-value-converter formControlName="object" [converter]="objectValueConverter">
          <soft-field-ok
            fieldOkName="objekt"
            [parameters]="{ status: 'O' }"
            #convertValue
            id="object"
          ></soft-field-ok>
        </soft-value-converter>
        @if (form.controls['object'].touched) {
          <soft-validation-container
            [validation]="form | validationMessage: 'object'"
            class="soft-property-validation"
          ></soft-validation-container>
        }
      </div>

      <div>
        <label class="soft-label top required" for="title">{{
          '#DOCUMENTATION.CREATE.TITLE' | translate
        }}</label>
        <soft-input formControlName="title"></soft-input>
      </div>

      <div>
        <label class="soft-label top" for="description">{{
          '#DOCUMENTATION.CREATE.DESCRIPTION' | translate
        }}</label>
        <soft-multiline-input
          formControlName="description"
          [lines]="2"
        ></soft-multiline-input>
      </div>
    </div>
  </div>
  <div class="flex flex-row justify-center mt-4">
    <div class="flex flex-col mt-2 mr-1 w-full">
      <soft-file-input
        #imageInput
        formControlName="files"
        [selectionMode]="'multi'"
      ></soft-file-input>
    </div>
  </div>
</form>

@if (isSaving$ | async) {
  <soft-blocking-loading-spinner></soft-blocking-loading-spinner>
}
